import store from '@/store'
import path from 'path-browserify'
import { isExternal } from './index'

/**
 * 判断是否与当前角色权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles) {
  if (store.getters['acl/admin']) {
    return true
  } else if (store.getters['setting/hidden']) {
    // 如果隐藏布局，用于iframe嵌套，则导入所有路由
    return true
  } else if (roles) {
    return store.getters['acl/role'].indexOf(roles) > -1
  } else {
    return true
  }
}

/**
 * @description 根据roles数组拦截路由
 * @param routes
 * @param baseUrl
 * @returns {[]}
 */
export function filterRoutes(routes, baseUrl = '/') {
  return routes
    .filter((route) => {
      if (route.meta && route.meta.roles) return hasPermission(route.meta.roles)
      else return true
    })
    .map((route) => {
      if (!route.isGroup) {
        if (route.path !== '*' && !isExternal(route.path)) route.path = path.resolve(baseUrl, route.path)
        route.fullPath = route.path
      }
      if (route.children) route.children = filterRoutes(route.children, route.fullPath)
      return route
    })
}

/**
 * @description 处理taburl的重定向内容
 * @param from
 * @returns {{path: *}|{path: *, query: {tab: (*|string)}}}
 */
export function getTabRedirectPath(from) {
  const pathList = from.path.split('/')
  const tabIndex = pathList.findIndex((v) => v.indexOf('_tab_') > -1)
  if (tabIndex > -1) {
    let redirectPathList = []
    pathList.forEach((item, i) => {
      if (i < tabIndex) {
        redirectPathList.push(item)
      }
    })
    const tab_string = pathList[tabIndex].split('_tab_')
    redirectPathList.push(tab_string[0])
    return {
      path: redirectPathList.join('/'),
      query: {
        tab: tab_string[1] || '',
      },
    }
  } else {
    return {
      path: from.path,
    }
  }
}

/**
 * @description 缓存历史页面
 * @param to
 */
export function setHistoryPath(to) {
  // 不进行缓存的页面
  const notCache = ['/', '/index', '/login', '/exception/404', '/question_neaten', '/ehafo_kanban/index']
  if (notCache.indexOf(to.path) === -1) {
    let historyList = []
    if (localStorage.getItem('historyPath')) {
      historyList = JSON.parse(localStorage.getItem('historyPath'))
      const existIndex = historyList.findIndex((v) => {
        if (to.meta.tabUrl) {
          // 如果是tabUrl则同时判断path与tab值
          return v.path === to.path && v.query.tab === to.query.tab
        } else {
          return v.path === to.path
        }
      })
      if (existIndex > -1) {
        // 如果已存在则删除原来的
        historyList.splice(existIndex, 1)
      }
      if (historyList.length === 9) {
        // 最多缓存9个
        historyList.pop()
      }
      // 在首位插入
      historyList.unshift({
        path: to.path,
        title: handleHistoryTitle(to),
        query: to.query,
      })
    } else {
      historyList.push({
        path: to.path,
        title: handleHistoryTitle(to),
        query: to.query,
      })
    }
    localStorage.setItem('historyPath', JSON.stringify(historyList))
  }
}

// 处理历史记录title显示
function handleHistoryTitle(to) {
  const matched = to.matched.filter((item) => !!item.meta.title)
  let titleList = []
  if (matched.length !== 1 || matched[0].path !== '/') {
    titleList = matched.map((v) => {
      if (v.meta.tabUrl) {
        return v.meta.tabArr[to.query.tab] || v.meta.title
      } else {
        return v.meta.title
      }
    })
  }
  let title = ''
  if (titleList.length === 0) {
    title = to.path.indexOf('/hrm/') > -1 ? '人资管理系统-' + to.meta.title : to.meta.title
  } else {
    title = titleList.join('-')
  }
  return title
}
